import { render, staticRenderFns } from "./TheNewsletter.vue?vue&type=template&id=01b51142&"
import script from "./TheNewsletter.vue?vue&type=script&lang=js&"
export * from "./TheNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports